import Modal from '../../common/model'
import { Box, Typography, styled } from '@mui/material'
import { translate } from '../../helper'
import BriefcaseIcon from '../../assets/image/svg/briefcase.js'
import phone from '../../../src/assets/image/svg/phone.svg'
import addressLoc from '../../../src/assets/image/svg/location.svg'
import { 
    AccountBalance,
    WorkOutline, HomeOutlined
} from '@mui/icons-material'

const BusinessInfoWrapper = styled('div')(({ theme }) => ({
    '& .business-info-section': {
        backgroundColor: '#F3F4F6',
        width: '100%',
        padding: 'var(--sp-lg)',
        borderRadius: 'var(--sp-md2)',
        marginBottom: 'calc(var(--sp-md2)*1.5)'
    },
    '& .info-row': {
        display: 'flex',
        alignItems: 'center',
        marginBottom: 'calc(var(--sp-md2)*1.5)',
        '&:last-child': {
            marginBottom: '0'
        }
    },
    '& .info-icon': {
        width: 'var(--fs-hero)',
        height: 'var(--fs-hero)',
        backgroundColor: '#E5E7EB',
        borderRadius: 'calc(var(--sp-xxs) * 2)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginRight: 'calc(var(--sp-md2)*1.5)',
        '& img': {
            width: 'var(--fs-xl)',
            height: 'var(--fs-xl)'
        },
        '& svg': {
            width: 'var(--fs-xl)',
            height: 'var(--fs-xl)'
        }
    },
    '& .info-content': {
        flex: 1
    },
    '& .info-label': {
        fontSize: 'var(--fs-md)',
        fontWeight: '600',
        color: '#6B7280',
        marginBottom: 'var(--sp-xxs)'
    },
    '& .info-value': {
        fontSize: 'calc(var(--fs-xs)*1.6)',
        fontWeight: '500',
        color: '#111827'
    }
}))

const BusinessAccountModal = ({ isOpen, onClose, orderDetail }) => {
    
    // Extract business account information from the new API response structure
    const businessAccount = orderDetail?.user?.business_accounts?.[0] || {}
    
    const businessInfo = {
        businessName: businessAccount?.business_name || 'Business Name',
        title: businessAccount?.business_title || 'Business Title',
        address: businessAccount?.business_address || 'Business Address',
        zipcode: businessAccount?.business_zip || 'Zipcode',
        phoneNumber: businessAccount?.business_phone_number || 'Phone Number',
        accountNumber: businessAccount?.business_account_number || 'Account Number',
    }

    return (
        <Modal
            title="businessAccountInfo"
            isOpen={isOpen}
            onClose={onClose}
        >
            <BusinessInfoWrapper>
                <Box className="business-info-section">
                    {/* Business Name */}
                    <Box className="info-row">
                        <Box className="info-icon">
                            <BriefcaseIcon />
                        </Box>
                        <Box className="info-content">
                            <Typography className="info-label">
                                {translate('businessName')}
                            </Typography>
                            <Typography className="info-value">
                                {businessInfo.businessName}
                            </Typography>
                        </Box>
                    </Box>
                    {/* Account Number */}
                    <Box className="info-row">
                        <Box className="info-icon">
                            <AccountBalance />
                        </Box>
                        <Box className="info-content">
                            <Typography className="info-label">
                                {translate('accountNumber')}
                            </Typography>
                            <Typography className="info-value">
                                {businessInfo.accountNumber}
                            </Typography>
                        </Box>
                    </Box>
                    {/* Business Title */}
                    <Box className="info-row">
                        <Box className="info-icon">
                            <WorkOutline />
                        </Box>
                        <Box className="info-content">
                            <Typography className="info-label">
                                {translate('businessTitle')}
                            </Typography>
                            <Typography className="info-value">
                                {businessInfo.title}
                            </Typography>
                        </Box>
                    </Box>
                    
                    {/* Business Address */}
                    <Box className="info-row">
                        <Box className="info-icon">
                            <HomeOutlined/>
                        </Box>
                        <Box className="info-content">
                            <Typography className="info-label">
                                {translate('businessAddress')}
                            </Typography>
                            <Typography className="info-value">
                                {businessInfo.address}
                            </Typography>
                        </Box>
                    </Box>

                    {/* Zipcode */}
                    <Box className="info-row">
                        <Box className="info-icon">
                            <img src={addressLoc} alt="zipcode" />
                        </Box>
                        <Box className="info-content">
                            <Typography className="info-label">
                                {translate('zipcode')}
                            </Typography>
                            <Typography className="info-value">
                                {businessInfo.zipcode}
                            </Typography>
                        </Box>
                    </Box>

                    {/* Business Phone Number */}
                    <Box className="info-row">
                        <Box className="info-icon">
                            <img src={phone} alt="phone" />
                        </Box>
                        <Box className="info-content">
                            <Typography className="info-label">
                                {translate('businessPhone')}
                            </Typography>
                            <Typography className="info-value">
                                {businessInfo.phoneNumber}
                            </Typography>
                        </Box>
                    </Box>

                    
                </Box>
            </BusinessInfoWrapper>
        </Modal>
    )
}

export default BusinessAccountModal
